/**
 * Who can open/send private chat (block on friendship only — not general "hidden" UI).
 */

export function isMessagingBlockedWithPlayer(otherId, friendsList) {
  if (!otherId) return false;
  const f = (friendsList || []).find((x) => x.id === otherId);
  return !!(f?.blockedByMe || f?.blocksMe);
}

export function filterFriendsEligibleForMessaging(friendsList) {
  return (friendsList || []).filter((f) => !isMessagingBlockedWithPlayer(f.id, friendsList));
}

export function getMessagingBlockedIdSet(friendsList) {
  return new Set(
    (friendsList || [])
      .filter((f) => f.blockedByMe || f.blocksMe)
      .map((f) => f.id)
  );
}

export function findFriendOnSquad(friendId, friendsList) {
  return (friendsList || []).find((f) => f.id === friendId) ?? null;
}
